export default [{
    title: 'Usuarios',
    icon: 'UsersIcon',
    children: [
        {
            title: 'Lista',
            route: 'user-management-list',
            action: 'manage',
		    resource: 'user-management'
        },
        {
            title: 'Nuevo',
            route: 'user-management-create',
            action: 'manage',
		    resource: 'user-management'
        },
        {
            title: 'Config. Aprobaciones',
            route: 'approval-config',
            action: 'manage',
		    resource: 'user-management'
        }
    ]
}];
